import { ActividadesEconomicasProvider } from "../../context/ActividadesEconomicasContext";
import { CoberturaProvider } from "../../context/CoberturaContext";
import { ConfirmarSolicitudProvider } from "../../context/ConfirmarSolicitudContext";
import { DatosCompaniaProvider } from "../../context/DatosCompaniaContext";
import { DomicilioFiscalProvider } from "../../context/DomicilioFiscalContext";
import { GiroPrincipalProvider } from "../../context/GiroPrincipalContext";
import { InformacionComplementariaProvider } from "../../context/InformacionComplementariaContext";
import ProveedoresPage from "./ProveedoresPage";
import { ProveedoresProspectosProvider } from "../../context/ProveedoresProspectosContext";
import { TipoPersonaProvider } from "../../context/TipoPersonaContext";
import { useRequest } from "../../context/RequestContext";

export default function ProveedoresProvidersPage() {
    const { serverHost } = useRequest();

    if (!serverHost) {
        return null;
    }

    return (
        <CoberturaProvider>
            <TipoPersonaProvider>
                <ActividadesEconomicasProvider>
                    <ProveedoresProspectosProvider>
                        <DatosCompaniaProvider>
                            <GiroPrincipalProvider>
                                <DomicilioFiscalProvider>
                                    <InformacionComplementariaProvider>
                                        <ConfirmarSolicitudProvider>
                                            <ProveedoresPage />
                                        </ConfirmarSolicitudProvider>
                                    </InformacionComplementariaProvider>
                                </DomicilioFiscalProvider>
                            </GiroPrincipalProvider>
                        </DatosCompaniaProvider>
                    </ProveedoresProspectosProvider>
                </ActividadesEconomicasProvider>
            </TipoPersonaProvider>
        </CoberturaProvider>
    );
}
